import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PageStack.html?raw';
import on from 'dojo/on';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TabEnabledMixin from './_TabEnabledMixin';
import FloatingMenu from '../Floating/Menu';
import _WidgetBase from 'dijit/_WidgetBase';
import aspect from 'dojo/aspect';
import query from 'dojo/query';
import _Container from 'dijit/_Container';
import "dijit/_Container";
import methodHooks from 'more/mdsMethodHooks';
//import DataItems = require("DataItems");

class PageStack extends methodHooks(compose(_WidgetBaseSP, _Container)) {
    templateString: any = template;

    private pages: Array<Tabbing.PageStackPage> = [];

    private _startupMissingNode: HTMLElement;

    private mainContainer: HTMLElement;
    private containerClasp: HTMLElement;
    private contentNode: HTMLElement;
    private tabRow: HTMLElement;
    private tabRowContainer: HTMLElement;
    private hiddenContainer: HTMLElement;

    private internalName: string;

    private activePage: Tabbing.PageStackPage;

    private _setNameAttr(name: string) {
        this.internalName = name;
    }

    hasPage(name: string): boolean {
        return this.getPageByName(name) != null;
    }

    addPage(element: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>> | HTMLElement | MdsLax<InstanceType<typeof _WidgetBase>>, preConfig?: Tabbing.PageDescriptor): Tabbing.PageStackPage {
        return this.placeElementIntoPageStack(element, preConfig);
    }

    /**
     * Inhalt für eine bestehende Page setzen.
     * Falls schon Inhalt vorhanden ist, wird er komplett ersetzt.
     * @param existingPageName
     * @param node
     * @returns
     */
    setPageContent(existingPageName: string, node:  HTMLElement, newLabel?: string, newIconClass?: string) {
        let page = this.getPageByName(existingPageName);

        if (!page) return;

        if (page.contentNode == node) return;

        if (page.contentNode) this.UiModder.domConstruct.destroy(page.contentNode);

        this.UiModder.domConstruct.place(node, this.hiddenContainer);

        page.contentNode = node;

        if (this.activePage?.name == existingPageName) {
            //this.activatePageByName(existingPageName);
            this.UiModder.domConstruct.place(node, this.contentNode);
        }

        if (newLabel || newIconClass) {
            this.setPageLabel(newLabel, newIconClass);
        }
        
    }

    setPageLabel(existingPageName: string, label: string, iconClass?: string, coloration?: string) {
        let page = this.getPageByName(existingPageName);

        if (!page) return;

        if (typeof (label) == "string") {
            page.label = label;
        }

        if (typeof (iconClass) != "undefined") {
            page.iconclass = iconClass;
        }

        if (typeof (coloration) != "undefined") {
            this.applyTabColor(page, coloration);
        }

        this.setNodeLabel(page.labelNode, page.label, page.iconclass);
    }

    hideTabRow(bIsHideTabRow: boolean) {
        this.hideNode(this.tabRowContainer, bIsHideTabRow);
    }

    placeElementIntoPageStack(element: MdsLax<InstanceType<ReturnType<typeof _TabEnabledMixin>>> | HTMLElement | MdsLax<InstanceType<typeof _WidgetBase>>, preConfig?: Tabbing.PageDescriptor): Tabbing.PageStackPage {

        if (!element) return;

        let targetNode: HTMLElement = null;
        let internalName: string = null;

        let isWidgetTabEnabledMixin = false;

        if (element instanceof _TabEnabledMixin) {
            targetNode = (element as any).domNode;
            internalName = (element as any).internalName ? (element as any).internalName : (element as any).id;
            // sonstiges spezial-Zeug bei TabEnabledMixin?

            isWidgetTabEnabledMixin = true;

        } else if (element instanceof _WidgetBase) {
            targetNode = (element as any).domNode;
            internalName = element.id;


        } else if (element instanceof HTMLElement) {
            targetNode = element;
            internalName = element.id ? element.id : "P-" + (Math.random() * 10000000).toFixed(0);
        }


        if (preConfig?.name) internalName = preConfig.name;



        let label = preConfig?.label;
        if (!label) label = (element as any).title;
        if (!label) label = internalName;

        if (this.canTranslate(label)) label = this.translate(label);

        let newPage: Tabbing.PageStackPage = {
            name: internalName,
            label: label,
            contentNode: null,
            visibleTab: typeof (preConfig.visibleTab) == "boolean" ? preConfig.visibleTab : true,
            enabled: typeof (preConfig.enabled) == "boolean" ? preConfig.enabled : true,
            //enableClosing: false, //preConfig?.enableClosing || false,
            labelNode: null,
            tabNode: null,
            sidebarNode: null,
            order: typeof (preConfig?.order) == "number" ? preConfig.order : this.pages.length * 10,
            //heading: element.title,
            contextButtons: [],
            iconclass: preConfig?.iconclass,
            //actionButtons: [],
            //actionMenuButtons: [],
            //topMenuButtons: [],
            actionMenuNode: null,
            topMenuNode: null,
            topMenuContainerNode: null,
            //bottomContextButtons: [],
            //sidebarEntryName: preConfig?.sidebarEntryName ? preConfig.sidebarEntryName : internalName
            insertWithoutPadding: preConfig?.insertWithoutPadding === true ? true : false
        };

       
        // prüfen ob schon vorhanden?
        let existingPage = this.getPageByName(newPage.name);
        if (existingPage) {
            // entfernen? besser abbrechen?
            return null;
        }


        element["internalName"] = newPage.name;
        //element.title = newPage.label;

        if (element instanceof HTMLElement) {
            
        } else {
            // die Funktion kapern:
            element["setTitles"] = lang.hitch(this, this._widgetTitleSetter, newPage);

            if (typeof (element["StandbyStart"]) == "function") {
                aspect.after(element, "StandbyStart", lang.hitch(this, this._afterStandbyStart, newPage));
                aspect.after(element, "StandbyStop", lang.hitch(this, this._afterStandbyStop, newPage));
                //aspect.after(element, "StandbyEnd", lang.hitch(this, this._afterStandbyStop, newPage))
            }

            on(element, "busyStart", lang.hitch(this, this._afterStandbyStart, newPage));
            on(element, "busyEnd", lang.hitch(this, this._afterStandbyStop, newPage));

        }
        this.pages.push(newPage);
        
        this.setPageContent(internalName, targetNode);

        this._sortPages();

        let tabNode = this.createTabNode(newPage);

        this.hideNode(this.tabRow, this.pages.length < 1);

        if (newPage.enabled != true) this.disablePage(newPage.name);
        if (newPage.visibleTab != true) this.hidePage(newPage.name);

        if (this.pages.length > 0 && this.activePage == null) this._activatePage(newPage);
        else this._recalcTabOverflow();

        //on(element, "requestSwitchTab", lang.hitch(this, this._onRequestSwitchTab));
        //on(element, "requestNewTab", lang.hitch(this, this._onRequestNewTab));
        //on(element, "requestNewContextButton", lang.hitch(this, this._onRequestNewContextButton, newPage));
        //on(element, "requestDisableContextButton", lang.hitch(this, this._onRequestDisableContextButton, newPage));
        //on(element, "requestRemoveContextButton", lang.hitch(this, this._onRequestRemoveContextButton, newPage));
        ////on(widget, "tabClosed", lang.hitch(this, this._onRequestTabclose, newPage.name));
        //on(element, "requestTabRename", lang.hitch(this, this._onRequestTabRename, newPage));
        //on(element, "requestTabRecolor", lang.hitch(this, this._onRequestTabRecolor, newPage));
        //on(element, "busyStart", lang.hitch(this, this._onTabBusy, true, newPage));
        //on(element, "busyEnd", lang.hitch(this, this._onTabBusy, false, newPage));
        //on(element, "dirty", lang.hitch(this, this._onTabDirty, newPage));

        if (newPage.enabled && this.activePage == null) this._activatePage(newPage);

        return newPage;
    }
    private getTabIndexByName(name: string): number {
        for (let index = 0; index < this.pages.length; index++) {
            let page = this.pages[index];
            if (page.name == name) {
                return index;
            }
        }
        return -1;
    }
    getPages(includeDisabled: boolean = true, includeHidden: boolean = false): Array<Tabbing.PageStackPage> {
        let pages: Array<Tabbing.PageStackPage> = [];
        for (let page of this.pages) {
            if ((page.enabled || includeDisabled === true) &&
                (page.visibleTab || includeHidden === true)) {
                pages.push(page);
            }
        }

        return pages;
    }
    getPageNames(includeDisabled: boolean = true, includeHidden: boolean = false): Array<Tabbing.PageStackPage> {
        let pages: Array<Tabbing.PageStackPage> = this.getPages(includeDisabled, includeHidden);

        let names = pages.map(page => page.name);

        return pages;
    }
    getPageByName(name: string): Tabbing.PageStackPage {
        let index = this.getTabIndexByName(name);

        if (index != -1) return this.pages[index];
    }


    private createTabNode(page: Tabbing.PageStackPage) {

        if (page.tabNode) this.UiModder.domConstruct.destroy(page.tabNode);

        let tabNode = this.UiModder.domConstruct.create("div", {
            className: "tab",
            style: { "order": page.order }
        }, this.tabRow, page.order);



        let selectorButton = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base hoverBright pageSelector",
            "innerHTML": page.label
        }, tabNode);


        this.setNodeLabel(selectorButton, page.label, page.iconclass);

        on(selectorButton, "click", lang.hitch(this, this._onClick_TabNode, page.name));

        if (page.coloration) {
            this.applyTabColor(page, page.coloration);
        }

        page.tabNode = tabNode;
        page.labelNode = selectorButton;

        return selectorButton;
    }

    private setNodeLabel(node: HTMLElement, label?: string, iconClass?: string) {

        if (label == null) label = "";

        if (typeof(label) == "string") node.innerHTML = label;

        if (iconClass) {
            let icon = this.createFontawesomeIcon(iconClass + " labelIcon", !!label ? "&nbsp;" : "");
            this.UiModder.domConstruct.place(icon, node, "first");
        }


        let spinner = this.createFontawesomeIcon("fas fa-circle-notch fa-spin spinner");
        this.UiModder.domConstruct.place(spinner, node, "first");

    }

    private _onClick_TabNode(pageName: string, evt: MouseEvent) {
        if (this.activePage?.name == pageName) return;
        let page = this.getPageByName(pageName);
        if (page) this._activatePage(page);
    }

  

    private applyTabColor(page: Tabbing.PageStackPage, coloration: string) {
        let node = page.tabNode;
        if (!node) return;
        if (!coloration) {
            node.style.removeProperty("--tabColor");
            node.style.removeProperty("color");
            page.coloration = null;
            this.UiModder.domClass.remove(node, "brightColor");
            return;
        }

        let dummy = this.UiModder.domConstruct.create("div", {}, this.hiddenContainer);
        let css = window.getComputedStyle(dummy);

        let defaultColorBG = css.backgroundColor;
        let defaultColorTxt = css.color;

        this.UiModder.domClass.add(dummy, coloration);
        css = window.getComputedStyle(dummy);

        let bgStyle = coloration;
        let txtStyle = "";

        //console.debug("computed linkstyle", css);

        // hat sich geändert durch die Klasse?
        if (css.backgroundColor != defaultColorBG) {
            bgStyle = css.backgroundColor;
        }

        if (css.color != defaultColorTxt) {
            txtStyle = css.color;
        }

        // so oder so sollten wir jetzt einen Style haben, den wir direkt auf die bg-Color-Variable setzen können
        if (bgStyle) {
            node.style.setProperty("--tabColor", bgStyle);
            try {
                if (!this.isDarkColor(bgStyle)) {
                    this.UiModder.domClass.add(node, "brightColor");
                }
            } catch (ex) {

            }
        }
        if (txtStyle) {
            this.UiModder.domStyle.set(node, "--tabColorTxt", txtStyle);
        }

        page.coloration = node.style.getPropertyValue("--tabColor");

        this.UiModder.domConstruct.destroy(dummy);
    }

    private _onTabDirty(config: Tabbing.PageStackPage, state: boolean) {
        if (config) {
            if (config.tabNode) {
                this.UiModder.domClass.toggle(config.tabNode, "dirty", state === true);
            }
            if (config.sidebarNode) {
                this.UiModder.domClass.toggle(config.sidebarNode, "dirty", state === true);
            }

           
        }
    }

    private _onRequestSwitchTab(name: string) {
        this.switchToPage(name);
    }



    private _hidePage(page?: Tabbing.PageStackPage, switchToOtherTab: boolean | string = true) {
        if (!page) {
            page = this.activePage;
        }

        if (!page) return;

        this.UiModder.domClass.remove(page.tabNode, "selected");
        this.UiModder.domConstruct.place(page.contentNode, this.hiddenContainer);

        //this._markPreviousPage(page);
        if (page.tabNode) {
            this.UiModder.domClass.remove(page.tabNode, "active");
        }

        if (page.topMenuNode) {
            this.hideNode(page.topMenuNode, true);
        }

        if (page.actionMenuNode) {
            this.hideNode(page.actionMenuNode, true);
        }

        if (page.contextButtons.length) {
            for (let buttonConfig of page.contextButtons) {
                if (buttonConfig.permanent != true) {
                    if (buttonConfig.node) {
                        this.UiModder.domClass.add(buttonConfig.node, "w3-hide");
                    }
                }
            }
        }

        this.activePage = null;
        let ownSort = page.order;

        if (switchToOtherTab == true) {
            for (let availablePage of this.pages) {
                if (availablePage.name != page.name && availablePage.order > ownSort) {
                    if (this._activatePage(availablePage) == true) return;
                }
            }
            // noch nicht umgeschaltet? nochmal, und sorting egal:
            for (let availablePage of this.pages) {
                if (availablePage.name != page.name) {
                    if (this._activatePage(availablePage) == true) return;
                }
            }
        } else if (typeof (switchToOtherTab) == "string") {
            for (let availablePage of this.pages) {
                if (availablePage.name == switchToOtherTab && availablePage.name != page.name) {
                    this._activatePage(availablePage);

                    break;
                }
            }
        }
    }

    /**
     * Rückgabe: true, wenn die Seite tatsächlich gewechselt worden ist.
     */
    switchToPage(name: string): boolean {
        return this.activatePageByName(name);
    }
    /**
     * Rückgabe: true, wenn die Seite tatsächlich gewechselt worden ist.
     */
    activatePageByName(name: string): boolean {
        let page = this.getPageByName(name);
        return this._activatePage(page);
    }

    getActivePageName(): string {
        return this.activePage?.name;
    }

    /**
     * Rückgabe: true, wenn die Seite tatsächlich gewechselt worden ist.
     */
    private _activatePage(page: Tabbing.PageStackPage, forceIfDisabled?: boolean, forceIfHidden?: boolean): boolean {
        if (!page) return false;

        if (page.enabled != true && forceIfDisabled !== true) return false;
        if (!page.visibleTab && forceIfHidden !== true) return false;


        if (this.activePage?.name === page.name) return false; // is es true, wenn sich nichts geändert hat?

        this._hidePage(this.activePage, false);

        this.UiModder.domConstruct.place(page.contentNode, this.contentNode);

        this.UiModder.domClass.add(page.tabNode, "selected");

        this.activePage = page;

        this.UiModder.domClass.toggle(this.contentNode, "noPadding", page.insertWithoutPadding === true);

        //this.removeUrlParameter("tc");
      
        this.handleColoration();

        this.emit("pageChange", page.name);
        this.emit("page", page.name);
        this.emit("pageSwitch", page.name);
        this.emit("pageSelected", page.name);
        this.emit("pageActivated", page.name);
        

        return true;
    }

    /**
     * Entfernt einen Tab inklusive Content komplett aus dem Pagestack. 
     * @param name
     * @returns
     */
    destroyPage(name: string): boolean {
        let keepPages = [];
        for (let page of this.pages) {
            if (page.name == name) {
                this._hidePage(page, true);
                this.UiModder.domConstruct.destroy(page.tabNode);
                this.UiModder.domConstruct.destroy(page.contentNode);
            } else {
                keepPages.push(page);
            }
        }

        if (this.pages.length == keepPages.length) return false;

        this.pages = keepPages;

        return true;
    }

    /**
     * Versteckt einen Tab temporär. Der Benutzer kann auf den Tab nicht mehr zugreifen, der Tab kann aber jederzeit reaktiviert werden.
     * Hinweis: Beim Reaktivieren (hide = false) wird der Tab nicht aktiviert. Dazu separat activatePage() aufrufen.
     * @param name
     */
    hidePage(name: string, hide: boolean = true): boolean {
        for (let page of this.pages) {
            if (page.name == name) {

                page.visibleTab = hide !== true;
                
                if (hide == true) {
                    if (this.activePage?.name == name) this._hidePage(page, true);

                    this.UiModder.domConstruct.place(page.tabNode, this.hiddenContainer);
                } else {
                    this.UiModder.domConstruct.place(page.tabNode, this.tabRow);
                }

                return true;
            } 
        }

        return false;
    }

    /**
     * Zeigt eine versteckte Seite wieder an und aktiviert sie bei Bedarf.
     */
    showPage(name: string, activate?: boolean) {
        if (this.hidePage(name, false) == true) {
            if (activate === true) this.switchToPage(name);
        }
    }

    /**
     * Deaktiviert einen Tab temporär.
     * Es können Tab (Schaltfläche) und Content getrennt (de-)aktiviert werden. Wenn die Tab-Schaltfläche deaktiviert wird, wird der Tab abgewählt.
     * @returns
     */
    disablePage(name: string, disableTab: boolean = true, disableContent?: boolean): boolean {
        for (let page of this.pages) {
            if (page.name == name) {
                if (page.enabled != !disableTab) {
                    page.enabled = disableTab !== true;

                    this.disableNode(page.tabNode, page.enabled === false);
                    this.disableNode(page.contentNode, disableContent === true || page.enabled != true);

                    if (!page.enabled && this.activePage?.name == name) this._hidePage(page, true);
                    else if (page.enabled && !this.activePage) this.switchToPage(page.name);

                    return true;
                }
                break;
            } 
        }

        return false;

    }
    /**
     * Reaktiviert einen deaktivierten Tab samt Inhalt.
     */
    enablePage(name: string, bEnable?: boolean) {
        this.disablePage(name, bEnable == false, bEnable == false);
    }

    private _busyPages: Array<string>;


    private _onPageBusy(targetState: boolean, page: Tabbing.PageStackPage) {
        this.UiModder.domClass.toggle(page.tabNode, "busy", targetState);
    }

    busyStart(page: Tabbing.PageStackPage) {
        if (!page) return;

        if (this._busyPages.length == 0) {
            this.emit("busy");
            this.emit("busyStart");
        }

        if (this._busyPages.indexOf(page.name) == -1) {
            this._busyPages.push(page.name);
            this._onPageBusy(true, page);
        }
    }

    busyEnd(page: Tabbing.PageStackPage) {

        if (!page) return;

        let index = this._busyPages.indexOf(page.name);

        if (index != -1) {
            this._busyPages.splice(index, 1);
            this._onPageBusy(false, page);
        }

        if (this._busyPages.length == 0) {
            this.emit("busyEnd");
        }
    }

    emitDirty(bDirty: boolean = true) {
        this.emit("dirty", bDirty);
    }

    private _afterStandbyStart(page: Tabbing.PageStackPage) {
        this.busyStart(page);
    }

    private _afterStandbyStop(page: Tabbing.PageStackPage) {
        this.busyEnd(page);
    }

    private handleColoration(targetPage?: Tabbing.PageStackPage): void {
        let page = targetPage;
        if (!page) page = this.activePage;

        if (page == this.activePage) {
            let css = window.getComputedStyle(page.tabNode);

            let colorValue = css.getPropertyValue("--bgColor");
            if (colorValue) {
                this.contentNode.style.setProperty("--containerColor", colorValue);
                //this.contentNode.style.setProperty("color", txtColorValue);
                this.containerClasp.style.setProperty("--containerColor", colorValue);

            } else {

                this.containerClasp.style.removeProperty("--containerColor");

            }
        }
    }

    private _recalcTabOverflow(): void {
        //let rect = this.tabRow.getBoundingClientRect();
        
        this.UiModder.domClass.remove(this.tabRowContainer, "tabOverflow minimal");
        return;
        if (this.pages.length > 4 || this.tabRowContainer.scrollWidth > this.tabRowContainer.clientWidth) {
            this.UiModder.domClass.add(this.tabRowContainer, "tabOverflow");

            // immer noch, weil vielleicht nicht detachable tabs auch noch da sind?
            if (this.tabRowContainer.scrollWidth > this.tabRowContainer.clientWidth) {
                this.UiModder.domClass.add(this.tabRowContainer, "tabOverflow minimal");
            }
        }
    }

    _onClick_TabSwitchMenu(evt: MouseEvent) {
        let menu = new FloatingMenu();

        for (let page of this.pages) {
            menu.addEntry({
                callback: lang.hitch(this, this._onRequestSwitchTab, page.name),
                label: page.label,
                coloration: page.coloration,
                enabled: page.name == this.activePage.name ? "selected" : page.name != this.activePage.name,
                icon: page.name == this.activePage.name ? "fas fa-eye" : page.iconclass,
                heading: null//page.label ? page.label : page.name
            });
        }

        menu.open(evt, null, this.title);
    }


    private _widgetTitleSetter(page: Tabbing.PageStackPage, windowtitle?: string, topbarTitle?: string) {
        if (!page || (!windowtitle && !topbarTitle)) return;

        this.setNodeLabel(page.labelNode, topbarTitle ? topbarTitle : windowtitle, page.iconclass);
    }

    private parseDocumentNodes() {
        let nodes = query("[data-pagestack-target]");
        let nodesContained = query("*", this.domNode);

        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i] as HTMLElement;

            if (nodesContained.indexOf(node) == -1) {

                let target = node.getAttribute("data-pagestack-target");
                if (target == this.internalName) {

                    this.addChild(node);
                }
            }
        }
    }

   
    /**
     * Achtung: Vererbung von dojo-Container. Diese Methode nicht von außerhalb programmatisch nutzen.
     * Stattdessen addPage verwenden!
     * @param element
     * @returns
     */
    addChild(element: MdsLax<InstanceType<typeof _WidgetBase>> | HTMLElement): void {
        // dojo-Funktion aus _Container: umleiten!
        if (!element) return;

        if (element instanceof _WidgetBase) {
            try {
                let preconfig: Tabbing.PageDescriptor = {
                    label: element.id,
                    name: element.id,
                    targetContainerName: this.internalName
                };

                let featureValue = element.domNode.getAttribute("data-feature-path");
                if (featureValue) {
                    if (!this.hasFeature(featureValue)) {
                        return; // nicht einbetten!
                    }
                }
                let privilegeValue = element.domNode.getAttribute("data-privilege-visible");
                if (privilegeValue) {
                    if (!this.hasUserRole(privilegeValue)) {
                        return; // nicht einbetten!
                    }
                }

                let labelValue = element.domNode.getAttribute("data-pagestack-label");
                if (labelValue) preconfig.label = labelValue;

                let nameValue = element.domNode.getAttribute("data-pagestack-name");
                if (labelValue) preconfig.name = nameValue;

                let iconValue = element.domNode.getAttribute("data-pagestack-icon");
                if (iconValue) preconfig.iconclass = iconValue;

                let visibleValue = element.domNode.getAttribute("data-pagestack-visible");
                if (visibleValue) {
                    visibleValue = visibleValue.toLowerCase();
                    if (visibleValue == "true" || visibleValue == "false") preconfig.visibleTab = visibleValue === "true";
                }
                let enabledValue = element.domNode.getAttribute("data-pagestack-enabled");
                if (enabledValue) {
                    enabledValue = enabledValue.toLowerCase();
                    if (enabledValue == "true" || enabledValue == "false") preconfig.enabled = enabledValue === "true";
                }

                try {
                    let orderValue = element.domNode.getAttribute("data-pagestack-order");
                    if (orderValue) preconfig.order = parseInt(orderValue);
                } catch (ex) {

                }

                this.placeElementIntoPageStack(element, preconfig);
                this._hidePage();
            } catch (ex) {
                console.warn(this.id + " addChild failed: " + ex, this, element);
            }
        } else if (element instanceof HTMLElement) {
            if (element.nodeType != 3) { // #text-Nodes nicht einfügen.... oder?
                let preconfig: Tabbing.PageDescriptor = {
                    label: element.id,
                    name: element.id,
                    targetContainerName: this.internalName
                };

                let featureValue = element.getAttribute("data-feature-path");
                if (featureValue) {
                    if (!this.hasFeature(featureValue)) {
                        return; // nicht einbetten!
                    }
                }
                let privilegeValue = element.getAttribute("data-privilege-visible");
                if (privilegeValue) {
                    if (!this.hasUserRole(privilegeValue)) {
                        return; // nicht einbetten!
                    }
                }

                let labelValue = element.getAttribute("data-pagestack-label");
                if (labelValue) preconfig.label = labelValue;

                let nameValue = element.getAttribute("data-pagestack-name");
                if (labelValue) preconfig.name = nameValue;

                let iconValue = element.getAttribute("data-pagestack-icon");
                if (iconValue) preconfig.iconclass = iconValue;


                let visibleValue = element.getAttribute("data-pagestack-visible");
                if (visibleValue) {
                    visibleValue = visibleValue.toLowerCase();
                    if (visibleValue == "true" || visibleValue == "false") preconfig.visibleTab = visibleValue === "true";
                }
                let enabledValue = element.getAttribute("data-pagestack-enabled");
                if (enabledValue) {
                    enabledValue = enabledValue.toLowerCase();
                    if (enabledValue == "true" || enabledValue == "false") preconfig.enabled = enabledValue === "true";
                }

                try {
                    let orderValue = element.getAttribute("data-pagestack-order");
                    if (orderValue) preconfig.order = parseInt(orderValue);
                } catch (ex) {

                }


                this.placeElementIntoPageStack(element, preconfig);
                this._hidePage();
            }
        }
    }

    private _sortPages() {
        if (this.pages.length >= 2) {
            this.pages.sort((a, b) => (a.order - b.order));
        }
    }

    buildRendering(): void {
        super.buildRendering.apply(this, arguments as any);

    }

    postCreate() {
        super.postCreate.apply(this, arguments as any);

        this.pages = [];
        this._busyPages = [];

        if (this.hasChildren()) {
            let count = 0;
            for (let child of this.getChildren()) {
                this.addChild(child);
                count++;
            }
        }

        if (this.containerNode.firstChild) {
            let childNodes: ChildNode[] = [];

            this.containerNode.childNodes.forEach(child => {
                childNodes.push(child);
            })
            for (let child of childNodes) {
                this.addChild(child as HTMLElement);
            }
        //    let count = 0;
        //    while (count < this.containerNode.childNodes.length) {
        //        this.addChild(this.containerNode.childNodes[count] as HTMLElement);
        //        count++;
        //    }
        }

        if (this.internalName) this.parseDocumentNodes();

        try {
            if (!this.activePage && this.pages.length > 0) this.switchToPage(this.pages[0].name);
        } catch (ex) {
            console.warn(this.id + ": no pages in pagestack?", this.domNode);
        }

    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any);

    }

    destroy() {
        super.destroy.apply(this, arguments as any);
    }

    startup() {
        super.startup.apply(this, arguments as any);

        try {
            if (this._startupMissingNode) {
                this.hideNode(this._startupMissingNode);
                this.UiModder.domConstruct.destroy(this._startupMissingNode);
            }
        } catch (ex) {

        }
    }

}

export default mdsWidget(PageStack);